<template>
  <a :href="basketUrl"
     class="btn mini-basket">
    <template v-if="loading">
      <font-awesome-icon icon="spinner"
                         class="icon"
                         aria-hidden="true"
                         spin></font-awesome-icon>
    </template>
    <template v-else>
      <font-awesome-icon :icon="['fal', 'shopping-basket']"
                         class="icon"
                         aria-hidden="true"></font-awesome-icon>
      <basket-item-quantity
        class="mini-basket__count"></basket-item-quantity>
    </template>
  </a>
</template>

<script>
import { BasketItemQuantity } from "spiritweb.packages.ecommerce";

export default {
  name: "MiniBasket",
  components: {
    BasketItemQuantity,
  },
  props: {
    basketUrl: {
      type: String,
      default: "#",
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../Styles/utils/colors.less";

.mini-basket {
  position: relative;
  font-size: 1.5rem;
  padding: 5px;
  width: 48px;
  height: 48px;

  &:hover {
    .icon {
      color: @color-primary;
    }
  }

  .icon {
    color: @color-primary;
    transition: color .2s ease-out;
    margin: 0;
  }

  &__count {
    position: absolute;
    top: 3px;
    left: calc(100% - 19px);
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    background-color: @color-primary;
    font-size: 0.63rem;
    border-radius: 100%;
    min-width: 18px;
    width: auto;
    height: 18px;
    z-index: 100;
  }
}
</style>
